interface TableSkeletonProps {
	rows?: number;
	columns?: number;
	className?: string;
}

import React from 'react';

/**
 * Skeleton loader for tables to prevent loading flash
 */
export const TableSkeleton = React.memo(function TableSkeleton({
	rows = 5,
	columns = 4,
	className = '',
}: TableSkeletonProps) {
	return (
		<div
			className={`w-full overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700 ${className}`}
		>
			<table className="w-full min-w-full divide-y divide-gray-200 dark:divide-gray-700">
				<thead className="bg-gray-50 dark:bg-gray-800">
					<tr>
						{Array.from({ length: columns }).map((_, colIndex) => (
							<th
								key={colIndex}
								className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
							>
								<div className="h-4 bg-gray-300 dark:bg-gray-600 rounded animate-pulse w-20"></div>
							</th>
						))}
					</tr>
				</thead>
				<tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
					{Array.from({ length: rows }).map((_, rowIndex) => (
						<tr key={rowIndex}>
							{Array.from({ length: columns }).map((_, colIndex) => (
								<td key={colIndex} className="px-6 py-4 whitespace-nowrap">
									<div className="flex items-center space-x-3">
										{colIndex === 0 && (
											<div className="h-6 w-6 bg-gray-300 dark:bg-gray-600 rounded animate-pulse"></div>
										)}
										<div className="space-y-2">
											<div className="h-4 bg-gray-300 dark:bg-gray-600 rounded animate-pulse w-24"></div>
											{colIndex === 0 && (
												<div className="h-3 bg-gray-200 dark:bg-gray-700 rounded animate-pulse w-16"></div>
											)}
										</div>
									</div>
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
});
